import { apiSlice } from './apiSlice';

/** Whatever the admin last uploaded under Admin → App Management. */
export interface ApkConfig {
  /** Absolute URL of the uploaded .apk, '' when nothing has been uploaded yet. */
  apkUrl: string;
  version: string;
  /** Admin's "Download Button Enable Karo" toggle. */
  isEnabled: boolean;
}

export const systemApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Public route (see SystemPublicController) — the download bar renders for
    // logged-out visitors too, so this must not sit behind the auth guard.
    getApkConfig: builder.query<ApkConfig, void>({
      query: () => ({ url: '/public/system/apk-config', method: 'GET' }),
    }),
  }),
});

export const { useGetApkConfigQuery } = systemApi;
